// import { ResponseEntity } from "../dto/response/common.type";
import { type AxiosInstance } from "axios";
import { ResponseEntity } from "../dto/response";

interface RequestOptions {
    headers?: Record<string, string>;
    params?: Record<string, any>;
    timeout?: number;
    responseType?: 'json' | 'blob' | 'arraybuffer' | 'document' | 'text' | 'stream';
}

const handleApiRequest = async <TResponse>(method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH', endpoint: string, API_SERVER: AxiosInstance, payload?: any, options: RequestOptions = {}): Promise<ResponseEntity<TResponse>> => {
    const responseEntity = new ResponseEntity<TResponse>();
    try {
        const config = {
            method,
            url: endpoint,
            data: method !== 'GET' ? payload : undefined,
            params: method === 'GET' ? payload : options.params,
            headers: options.headers || {},
            timeout: options.timeout || 30000,
            responseType: options.responseType || 'json'
        };
        const response = await API_SERVER.request(config);
        if (options.responseType === 'blob') {
            responseEntity.success(response.data, response.status, 'File download success');
        } else {
            responseEntity.success(response.data.body, response.status, response.data.message);
        }

    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(
            response?.status || 500,
            error?.Message || error?.message || 'Something went wrong',
            response?.data?.body || {}
        );
    }
    return responseEntity;
};


export const handleGetRequest = async <T>(
    url: string,
    params: any,
    SERVER_URL: AxiosInstance,
    headers?: Record<string, string>
): Promise<ResponseEntity<T>> => {
    return handleApiRequest<T>("GET", url, SERVER_URL, { params, headers });
};

export const handlePostRequest = async <T>(url: string, payload: any, SERVER_URL: AxiosInstance, options: RequestOptions = {}): Promise<ResponseEntity<T>> => {
    return handleApiRequest<T>("POST", url, SERVER_URL, payload, options);
};
